import * as React from "react";
import sgLogo from "assets/images/eventItemImg.png";

const DashboardHeader: React.FC = () => {
  return (
    <div className="pb-4">
      <div className="d-flex">
        <div className="col-6 d-flex align-items-center">
          <div className="">
            <h1 className="display-2">All events</h1>
            <h6 className="text-secondary">Find out about the event recommended to you</h6>
          </div>
        </div>
        <img className="col-6 h-100" src={sgLogo} alt="Logo SG" height="32" />
      </div>
    </div>
  );
};

export default DashboardHeader;
